var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('data-list-component',{attrs:{"module":_vm.userStoreModule,"use-list":_vm.userDataList,"use-side-bar":_vm.useSideBar,"module-name":"app-users"}})}
var staticRenderFns = []

export { render, staticRenderFns }